import { createApolloProvider } from '@vue/apollo-option';
import apollo from './apollo';

const apolloProvider = createApolloProvider({
  defaultClient: apollo.apolloClient,
});

export default apolloProvider;
